import BTooltip from './tooltip';

export default { BTooltip };